// TODO QS-10687: Replace with the official third-party logo when available.
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioGitbookIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-gitbook-prod" */ './utils').then(
			(m) => m.ForgePioGitbookIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon' },
);

const LazyForgePioGitbookSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-gitbook-prod-search-result" */ './utils').then(
			(m) => m.ForgePioGitbookSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGitbookIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGitbookIconComponent />
	</Suspense>
);

export const ForgePioGitbookSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGitbookSearchResultIconComponent />
	</Suspense>
);
